import gql from "graphql-tag";

export const IS_DAILY_PUBLISHING = gql`
    query IsDailyPublishing {
        isDailyPublishing
    }
`;

export const UPDATE_DAILY_PUBLISHING = gql`
    mutation UpdateDailyPublishing($enabled: Boolean!) {
        updateDailyPublishing(enabled: $enabled)
    }
`;

export const PUBLISH_NOW = gql`
    mutation PublishNow {
        publishNow
    }
`;

export const PUBLISH_HISTORY_LOGS = gql`
    query PublishHistoryLogs {
        publishHistoryLogs {
            publishHistoryId
            publishSteps {
                serialId
                step
                stepDef
                startDate
                endDate
                result
                log
            }
        }
    }
`;
